// extracted by mini-css-extract-plugin
export default {"container":"InvestigationNotification_container__iI0NV","header":"InvestigationNotification_header__qIBe4","status":"InvestigationNotification_status__C0AYu"};